module.exports = __webpack_public_path__ + "static/media/unicorn-platform-logo.04bff9ca.svg";